import axios from "axios";
import { API_BASE_URL } from "utils/api";
import { getToken } from "utils/auth";

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const addClientSchedule = async ({ clientId, scheduledTime, note }) => {
  const response = await api.post("/clients/add-schedule", {
    clientId,
    scheduledTime,
    note,
  });

  return response?.data;
};

export const addClientNote = async ({ clientId, note }) => {
  const response = await api.post("/clients/add-note", {
    clientId,
    note,
  });

  return response?.data;
};

export const getClientNoteScheduleDetails = async (clientId) => {
  const response = await api.get(`/clients/${encodeURIComponent(clientId)}/note-schedule-details`);
  return response?.data;
};

export const deleteClientNote = async (clientId, noteId) => {
  const response = await api.delete(
    `/clients/${encodeURIComponent(clientId)}/note/${encodeURIComponent(noteId)}`
  );
  return response?.data;
};

export const deleteClientSchedule = async (clientId, scheduleId) => {
  const response = await api.delete(
    `/clients/${encodeURIComponent(clientId)}/schedule/${encodeURIComponent(scheduleId)}`
  );
  return response?.data;
};

export const addClientInstallment = async (clientId, payload) => {
  const response = await api.post(`/clients/${encodeURIComponent(clientId)}/installments`, payload);
  return response?.data;
};
